// todo add events...

export const EVENT_NAME_GENERAL_CUSTOM = 'general_custom_event';

//1. zobrazeni - i po navratu ze hry !!! - see mereni.pdf
// export const ANALYTICS_TITLE = 'Velikonoční poklad';
// export const ANALYTICS_CATEGORY = 'velikonoce';
// export const ANALYTICS_SECTION = 'decko';

//2. klik na postavicku - drive 4 - ACTION_OPEN_INFO
//"param1": "activity_open_info",
//"param2": "Koumej kolem dokola"
export const EVENT_OPEN_INFO = 'activity_open_info';

//3. tlacitko v InfoBubble - drive 5 - ACTION_OPEN_POPUP
//"param1": "activity_start",
//"param2": "Koumej kolem dokola
export const EVENT_ACTIVITY_START = 'activity_start';

//4. klik na objekt
//"param1": "quest_item_click",
//"param2": "perníek se zajíkem"
export const EVENT_OBJECT_CLICK = 'quest_item_click';

//5. object collected
//"param1": "quest_score",
//"param2": "4"
export const EVENT_OBJECT_DONE = 'quest_score';

//6. stazeni omalovanek
//"param1": "quest_prize_download"
export const EVENT_PRIZE_DOWNLOAD = 'quest_prize_download';

//8. Zobrazení a skrytí nápovědy
export const EVENT_HELP_SHOW = 'help_show';

//8. Zobrazení a skrytí nápovědy
export const EVENT_HELP_HIDE = 'help_hide';

//9. Zapnutí a vypnutí hudby
export const EVENT_MUSIC_SWITCH_ON = 'music_switch_on';

//9. Zapnutí a vypnutí hudby
export const EVENT_MUSIC_SWITCH_OFF = 'music_switch_off';

//10. Audio postaviček
export const EVENT_ACTIVITY_HOVER_INFO = 'activity_hover_info';

//11. Zobrazení tlačítka pro přechod do appstore
export const EVENT_APP_STORE_REDIRECT_IMPRESSION = 'app_store_redirect_impression';

//12. Proklik tlačítka pro přechod do appstore
export const EVENT_APP_STORE_REDIRECT_CLICK = 'app_store_redirect_click';

declare global {
  interface Window {
    DP: any; // 👈️ turn off type checking
    dpAnalytics: any;
    tingle: any;
    Howler: any;
  }
}

export const sendCustomEvent = (eventName: string, param?: string | number) => {
  if (window.DP && window.DP.analytics && window.dpAnalytics) {
    try {
      const eventBuilder = new window.DP.analytics.EventBuilder()
        .setEventName(EVENT_NAME_GENERAL_CUSTOM)
        .setCustom(eventName, param);

      if (eventName === EVENT_OBJECT_DONE) {
        eventBuilder.setInteraction(false);
      } else {
        eventBuilder.setInteraction(true);
      }
      window.dpAnalytics.trackEvent(eventBuilder);
      // eslint-disable-next-line no-empty
    } catch (exception) {}
  } else {
    console.warn('dpAnalytics is undefined');
  }
};

export const sendViewEvent = () => {
  if (window.DP && window.DP.analytics && window.dpAnalytics) {
    try {
      const eventBuilder = new window.DP.analytics.EventBuilder()
        .setEventName('other_view')
        .setApp(window.dpAnalytics.pageParams.app.platform, window.dpAnalytics.pageParams.app.version)
        .setUser(window.dpAnalytics.pageParams.user.id)
        .setInteraction(true)
        .setPageTitle('Velikonoční návštěva 2024')
        .setPageType('other')
        .setPageSection('Decko')
        .addPageCategories(['velikonoce']);
      window.dpAnalytics.trackEvent(eventBuilder);
      //window.dpAnalytics.trackEvent(window.dpAnalytics.pageParams); TODO: Not working?
      // eslint-disable-next-line no-empty
    } catch (exception) {}
  } else {
    console.warn('dpAnalytics is undefined');
  }
};
